import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";

import { Button, Modal } from '../DesignSystem'

import "./index.scss";
import data from "./mock-data.json";
import ReadOnlyRow from "./components/ReadOnlyRow";
import EditableRow from "./components/EditableRow";

function SignDraft({ show, onClose }) {

    const [contacts, setContacts] = useState(data);
    const [update, setUpdate] = useState(false)

    const [editFormData, setEditFormData] = useState({
        id: "",
        name: "",
        cpf: "",
        email: "",
        blocked: "",
    });

    const [editContactId, setEditContactId] = useState(null);

    useEffect(() => {
        axios
            .get("/proposal/signDraft")
            .then((response) => {
                <Fragment key={response}>{
                    setContacts(response.data)
                }
                </Fragment>
            })
            .catch((e) => {
                console.error("Error on get signDraft:", e);

            });
    }, [])

    const handleEditFormChange = (event) => {
        event.preventDefault();

        const name = event.target.getAttribute("name");
        const fieldValue = event.target.value;

        const newFormData = { ...editFormData };
        newFormData[name] = fieldValue;

        setEditFormData(newFormData);
    };

    const handleEditFormSubmit = (event) => {
        event.preventDefault();

        const editedContact = {
            id: editContactId,
            name: editFormData.name,
            cpf: editFormData.cpf,
            email: editFormData.email,
            blocked: editFormData.blocked,
        };

        const newContacts = [...contacts];

        const index = contacts.findIndex((contact) => contact.id === editContactId);

        console.log("editedContact", editedContact)

        newContacts[index] = editedContact;

        axios
            .put("/proposal/change-signDraft", { name: editedContact.name, cpf: editedContact.cpf, email: editedContact.email, blocked: editedContact.blocked, contact_id: editContactId })
            .then((response) => {
                setContacts(newContacts);
                setEditContactId(null);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleEditClick = (event, contact) => {
        event.preventDefault();
        setEditContactId(contact.id);

        const formValues = {
            name: contact.name,
            cpf: contact.cpf,
            email: contact.email,
            blocked: contact.blocked,
        };

        setEditFormData(formValues);
    };

    const handleCancelClick = () => {
        setEditContactId(null);
    };

    function renderFooter() {
        return (
            <div style={{ gap: '8px' }}>
                <Button onClick={onClose}>Cancelar</Button>
            </div>
        )
    }

    return (
        <Modal
            show={show}
            modalWidth={1520}
            title={"Assinantes da Minuta"}
            renderFooter={renderFooter()}
            onClose={onClose}
        >
            <div className="app-container">
                <form onSubmit={handleEditFormSubmit}>
                    <table>
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>CPF</th>
                                <th>Email</th>
                                <th>Férias</th>
                                <th>Ação</th>
                            </tr>
                        </thead>
                        <tbody>
                            {contacts.map((contact) => (
                                <Fragment key={contact.id}>
                                    {editContactId === contact.id ? (
                                        <EditableRow
                                            editFormData={editFormData}
                                            handleEditFormChange={handleEditFormChange}
                                            handleCancelClick={handleCancelClick}
                                            handleEditFormSubmit={handleEditFormSubmit}
                                        />
                                    ) : (
                                        <ReadOnlyRow
                                            contact={contact}
                                            handleEditClick={handleEditClick}
                                        /*  handleDeleteClick={handleDeleteClick} */
                                        />
                                    )}
                                </Fragment>
                            ))}
                        </tbody>
                    </table>
                </form>
            </div>
        </Modal>
    );
}

export default SignDraft;